module.exports = __webpack_public_path__ + "img/9791157231867.8ae9ba61.jpg";